import { Carousel } from "antd";
import XtSvg from "@/components/Xt/Svg";
import styles from "./index.module.less";

export default ({ arrows = true, autoplay = true, autoplaySpeed = 3000, infinite = true, slidesToShow = 3, slidesToScroll = 1, children }) => {
  return (
    <div className={styles.main}>
      <Carousel
        arrows={arrows}
        autoplay={autoplay}
        autoplaySpeed={autoplaySpeed}
        infinite={infinite}
        slidesToShow={slidesToShow}
        slidesToScroll={slidesToScroll}
        prevArrow={
          <div>
            <XtSvg icon="arr-left" />
          </div>
        }
        nextArrow={
          <div>
            <XtSvg icon="arr-right" />
          </div>
        }
      >
        {children}
      </Carousel>
    </div>
  );
};
